import { LoanType } from './LoanType';

export const LoanTypeOptions = [
    {
        id: '',
        name: 'Loan Type...',
        shortName: '',
    },
    {
        id: LoanType.Construction,
        name: 'Construction',
        shortName: 'Const.',
    },
    {
        id: LoanType.Rental,
        name: 'Rental',
        shortName: 'Rental',
    },
    {
        id: LoanType.BuildRent,
        name: 'Build-Rent',
        shortName: 'Bld-Rent',
    },
    {
        id: LoanType.Model,
        name: 'Model',
        shortName: 'Model',
    },
    {
        id: LoanType.Land,
        name: 'Land',
        shortName: 'Land',
    },
    {
        id: LoanType.FixFlip,
        name: 'Fix-Flip',
        shortName: 'Fx-Flp',
    },
    {
        id: LoanType.MasterNote,
        name: 'Master Note',
        shortName: 'Mstr Nte',
    },
    {
        id: LoanType.SubNoteConstruction,
        name: 'Construction LOC',
        shortName: 'Const. LOC',
    },
    {
        id: LoanType.SubNoteFixFlip,
        name: 'Fix-Flip LOC',
        shortName: 'Fix-Flip LOC',
    },
];
